<template>
    <v-dialog v-model="displayForm" persistent max-width="980px">
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-card>
          <v-card-title>
            <span class="headline" v-if="item">Update Currency</span>
            <span class="headline" v-else>Add Currency</span>
          </v-card-title>
          <div class="text-xs-center">
            <v-progress-circular indeterminate color="primary" v-if="loading"></v-progress-circular>
          </div>
          <v-card-text v-if="!loading">
            <v-alert
              :value="messages.length > 0"
              type="error"
              dismissible
              transition="scale-transition"
            >
              <div v-for="message in messages" :key="message">{{ message }}</div>
            </v-alert>

            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 md4>
                  <v-text-field v-model="model.key" label="Pair" :rules="mandatoryRules"></v-text-field>
                </v-flex>
                <v-flex xs12 md4>
                  <v-text-field v-model="model.rate" label="Rate" :rules="mandatoryRules"></v-text-field>
                </v-flex>
                <v-flex xs12 md4>
                    <v-menu
                        v-model="menuDate"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="290px"
                    >
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                                v-model="model.effectiveDate"
                                label="Effective date"
                                prepend-icon="mdi-calendar"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                            ></v-text-field>
                        </template>
                        <v-date-picker
                            v-model="model.effectiveDate"
                            @input="menuDate = false"
                        ></v-date-picker>
                    </v-menu>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="cancel()" :disabled="loading">Cancel</v-btn>
            <v-btn
              v-if="item"
              color="blue darken-1"
              text
              @click="update()"
              :disabled="loading"
            >Update</v-btn>
            <v-btn v-else color="blue darken-1" text @click="add()" :disabled="loading">Add</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
</template>

<script>
function getDefaultData() {
  return {
    model: {
      id: null,
      key: null,
      rate: null,
      effectiveDate: null
    },
    menuDate:null,
    mandatoryRules: [v => !!v || "This fiels is mandatory"],
    messages: [],
    valid: null
  };
}
export default {
  props: ["item", "open", "id"],
  data: getDefaultData,
  computed: {
    displayForm: function() {
      return this.open;
    },
    loading: function() {
      return this.$store.getters["currencies/loading"];
    }
  },
  watch: {
    item: function(newVal) {
      // watch it
      Object.assign(this.model, newVal);
    }
  },
  methods: {
    add() {
      this.messages = []
      if (this.$refs.form.validate()) {
        this.model.locationId = this.id;
        this.$store
          .dispatch("currencyRates/add", {
            model: this.model
          })
          .then(() => {
            this.$emit("add");
            this.resetForm();
          })
          .catch(({data}) => {
            this.messages.push(data.message)
            for (const error of Object.entries(data.errors)) {
              this.messages.push(error[1][0])
            }
          })
      }
    },
    update() {
      this.messages = []
      if (this.$refs.form.validate()) {
        this.$store
          .dispatch("currencyRates/update", {
            model: this.model
          })
          .then(() => {
            this.$emit("update");
            this.resetForm();
          })
          .catch(({data}) => {
            this.messages.push(data.message)
            for (const error of Object.entries(data.errors)) {
              this.messages.push(error[1][0])
            }
          })
      }
    },
    cancel() {
      this.$emit("cancel");
      this.resetForm();
    },
    resetForm() {
      Object.assign(this.$data, getDefaultData());
      this.$refs.form.reset();
    }
  }
};
</script>

<style></style>
